import type { User } from "@/features/users/schemas/user";
import { getUserFullName } from "@/features/users/utils/user-utils";

/** Etiqueta del verificador (email o nombre). */
export function getVerifierLabel(user: User | null | undefined): string {
  if (!user) return "";
  return user.email?.trim() || getUserFullName(user) || "";
}

/** Payload de verificación: fecha de hoy + quién verificó. */
export function buildHostVerificationPayload(verifiedBy: string) {
  return {
    verifiedAt: new Date().toISOString().slice(0, 10),
    verifiedBy: verifiedBy.trim(),
  };
}
